<script setup lang="ts">
import { useRoute } from "vue-router";
import { LinkedinLogoIcon } from "@radix-icons/vue";
import { Rss } from "lucide-vue-next";
import { FooterDto } from "@/components/Dto/Layout/FooterDto";
import Link from "../tags/Link.vue";

const route = useRoute();

function blurActiveElement() {
    const activeElement = document.activeElement;

    if (
        activeElement instanceof HTMLInputElement ||
        activeElement instanceof HTMLTextAreaElement ||
        activeElement instanceof HTMLElement
    ) {
        activeElement.blur();
    }
}
</script>

<template>
    <footer class="lg:layout fixed bottom-0 lg:relative lg:container min-w-full border-t text-dark z-50 lg:z-auto"
        data-testid="Footer">
        <ul class="hidden lg:flex gap-0 flex-row justify-around items-center w-full py-12">
            <li class="flex flex-col gap-4">
                <Image src="/logo.svg" alt="NEI Logo" width="200" height="71.59" />
                <span v-translate>© 2024 Todos os direitos reservados.</span>
            </li>
            <li class="flex flex-col gap-5 self-start">
                <h2 v-translate>Informações</h2>
                <article class="flex flex-col gap-2">
                    <div>
                        <RouterLink to="/about-us" class="hover:opacity-50">
                            <span v-translate>Sobre Nós</span>
                        </RouterLink>
                    </div>
                    <div>
                        <RouterLink to="/privacy-policy" class="hover:opacity-50">
                            <span v-translate>Política de Privacidade</span>
                        </RouterLink>
                    </div>
                    <div>
                        <RouterLink to="/cookie-policy" class="hover:opacity-50">
                            <span v-translate>Política de Cookies</span>
                        </RouterLink>
                    </div>
                    <div>
                        <RouterLink to="/terms-of-service" class="hover:opacity-50">
                            <span v-translate>Termos de Uso</span>
                        </RouterLink>
                    </div>
                    <div>
                        <RouterLink to="/more#tools" class="hover:opacity-50">
                            <span v-translate>Ferramentas</span>
                        </RouterLink>
                    </div>
                </article>
            </li>
            <li class="flex flex-col gap-5">
                <h2 v-translate>Modo Escuro</h2>
                <ToggleTheme variant="airplane" />
                <h2 v-translate>Redes Sociais</h2>
                <Link href="https://www.linkedin.com/company/nei-market-analytics/" target="_blank">
                    <div class="flex gap-3">
                        <LinkedinLogoIcon class="w-6 h-6" />
                        <span v-translate>Ver no Linkedin</span>
                    </div>
                </Link>
                <RouterLink to="/blog" class="flex gap-3 hover:opacity-50">
                    <Rss class="w-6 h-6" />
                    <span v-translate>Blog</span>
                </RouterLink>
            </li>
        </ul>
        <ul class="grid grid-cols-5 bg-secondaryDarker w-full h-full lg:hidden">
            <li v-for="(data, i) in FooterDto" :key="i"
                :class="{ 'text-link': route.path === data.path, 'cursor-pointer hover:text-link transition-colors duration-150 ease-in-out': true }">
                <RouterLink :to="data.path" class="flex flex-col items-center p-3" @click="blurActiveElement">
                    <component :is="data.icon" class="w-6 h-6" />
                    <span v-translate class="text-sm font-semibold">{{ data.title }}</span>
                </RouterLink>
            </li>
        </ul>
    </footer>
</template>

<style scoped>
h2 {
    @apply text-text;
}
</style>
